import type { ZeroTransform } from './types'

export const ZERO_TRANSFORM: ZeroTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1,
  scaleZ: 1,
  rotation: 0,
  extrusionX: 0,
  extrusionY: 0,
  extrusionZ: 1,
}

